import { render, staticRenderFns } from "./MagTransform.vue?vue&type=template&id=7196c1c0&scoped=true&"
import script from "./MagTransform.vue?vue&type=script&lang=js&"
export * from "./MagTransform.vue?vue&type=script&lang=js&"
import style0 from "./MagTransform.vue?vue&type=style&index=0&id=7196c1c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7196c1c0",
  null
  
)

export default component.exports